import { isDesktop } from '../../services/service-utils';

export default class DesktopMenu {
  constructor(element) {
    this.el = element;
    this.menuIsVisible = true;
    this.lastScrollTop = 0;
    this.hideMenuWithAnimation = this.hideMenuWithAnimation.bind(this);
    this.showMenuWithAnimation = this.showMenuWithAnimation.bind(this);
    this.init();
  }

  init() {
    if (isDesktop()) {
      window.addEventListener('DOMContentLoaded', () => {
        const pageType = document.body.getAttribute('data-page-type');
        if (pageType !== 'projectContainerPage' && pageType !== 'GdwWalkContainerPage') {
          this.attachScrollListener();
        } else {
          document.querySelector('#main').classList.remove('lg:pt-header', 'pt-header-mobile');
          this.el.classList.add('relative');
        }
      });
    }
  }

  attachScrollListener() {
    window.addEventListener(
      'scroll',
      () => {
        const scrollTop = window.scrollY;
        if (scrollTop > this.lastScrollTop && this.menuIsVisible) {
          this.hideMenuWithAnimation();
          this.menuIsVisible = false;
        } else if (scrollTop <= this.lastScrollTop && !this.menuIsVisible) {
          this.showMenuWithAnimation();
          this.menuIsVisible = true;
        }
        this.lastScrollTop = scrollTop;
      },
      { passive: true }
    );
  }

  hideMenuWithAnimation() {
    this.el.classList.add('-translate-y-full');
    this.el.classList.remove('translate-y-0');
    document.dispatchEvent(new Event('menuHidden'));
  }

  showMenuWithAnimation() {
    this.el.classList.add('translate-y-0');
    this.el.classList.remove('-translate-y-full');
  }
}
